import {useSystemHistory} from './base'
import {HistoryFetch, HistoyFetchPaginationParams} from '../../fetch_history'

export type HistoryFetchParams = Partial<HistoyFetchPaginationParams> & {
  targetId?: number
  targetType?: string
  startDate?: string
  endDate?: string
}

export function useSystemHistoryList(initialParams = {}) {

  const fetchHistory = async ({limit, currentPage}: HistoyFetchPaginationParams) => {
    return await new HistoryFetch({
      limit,
      currentPage
    }).fetchHistoryList()
  }

  return useSystemHistory(initialParams, fetchHistory)
}

export function useSystemHistoryByObject(initialParams: HistoryFetchParams) {

  const fetchHistory = async ({limit, currentPage, targetType, targetId}: HistoryFetchParams) => {
    return await new HistoryFetch({
      limit,
      currentPage
    }).fetchHistorybyObject(targetType, targetId)
  }

  return useSystemHistory({targetType: null, targetId: null, ...initialParams}, fetchHistory)
}

export function useSystemHistoryByDates(initialParams: HistoryFetchParams) {
  const fetchHistory = async ({limit, currentPage, startDate, endDate}: HistoryFetchParams) => {
    const fetch = new HistoryFetch({limit, currentPage})
    const {count, items} = await fetch.fetchHistoryByDate(startDate, endDate)
    return {count, items}
  }

  return useSystemHistory({startDate: null, endDate: null, app: null, selectedApp: 'admin', ...initialParams}, fetchHistory)
}